export default __webpack_public_path__ + "static/media/edit.4c905ec5.svg";